<template>
  <div class="fixed flex flex-col right-[0.1vw] top-[50%] z-50 gap-[0.1vw]">
    <!-- 电话 -->
    <div
      class="relative group w-[3vw] h-[3vw] bg-[#9CA3AFCC] flex items-center justify-center hover:bg-[#05358CCC] cursor-pointer"
    >
      <i class="el-icon-phone-outline text-[1.4vw] text-white" alt="电话"></i>
      <div
        class="absolute right-full w-[8.9vw] h-[3vw] p-[0.5vw] bg-[#05358CCC] text-white font-harmony font-regular text-[1vw] transform scale-x-0 opacity-0 transition-all duration-300 origin-right whitespace-nowrap group-hover:scale-x-100 group-hover:opacity-100 flex justify-center items-center will-change-auto"
      >
        400 0336 691
      </div>
    </div>

    <!-- 微信 -->
    <div
      class="relative group w-[3vw] h-[3vw] bg-[#9CA3AFCC] flex items-center justify-center hover:bg-[#05358CCC] cursor-pointer"
    >
      <i class="el-icon-chat-round text-[1.4vw] text-white" alt="微信"></i>
      <div
        class="absolute right-[3.1vw] size-[8.8vw] p-[0.1vw] bg-[#05358CCC] hidden transform group-hover:flex items-center"
      >
        <img
          src="@/assets/images/Footer/weixin.png"
          alt="二维码"
          class="w-full h-full object-cover overflow-hidden"
        />
      </div>
    </div>

    <!-- 跳转链接1 -->
    <div
      class="relative group w-[3vw] h-[3vw] bg-[#9CA3AFCC] flex items-center justify-center hover:bg-[#05358CCC] cursor-pointer"
      @click="$router.push({ name: 'CourseSystem' })"
    >
      <i class="el-icon-collection text-[1.4vw] text-white" alt="课程体系"></i>
      <div
        class="absolute right-full w-[6vw] h-[3vw] p-[0.5vw] bg-[#05358CCC] text-white font-harmony text-[1vw] transform scale-x-0 opacity-0 transition-all duration-300 origin-right whitespace-nowrap group-hover:scale-x-100 group-hover:opacity-100 flex justify-center items-center will-change-auto"
      >
        课程体系
      </div>
    </div>

    <!-- 跳转链接2 -->
    <div
      class="relative group w-[3vw] h-[3vw] bg-[#9CA3AFCC] flex items-center justify-center hover:bg-[#05358CCC] cursor-pointer"
      @click="$router.push({ name: 'Competition' })"
    >
      <i class="el-icon-trophy text-[1.4vw] text-white" alt="白名单赛事"></i>
      <div
        class="absolute right-full w-[6vw] h-[3vw] p-[0.5vw] bg-[#05358CCC] text-white font-harmony text-[1vw] transform scale-x-0 opacity-0 transition-all duration-300 origin-right whitespace-nowrap group-hover:scale-x-100 group-hover:opacity-100 flex justify-center items-center will-change-auto"
      >
        白名单赛事
      </div>
    </div>

    <!-- 跳转链接3 -->
    <div
      class="relative group w-[3vw] h-[3vw] bg-[#9CA3AFCC] flex items-center justify-center hover:bg-[#05358CCC] cursor-pointer"
      @click="$router.push({ name: 'JoinUs' })"
    >
      <i
        class="el-icon-office-building text-[1.4vw] text-white"
        alt="全国加盟"
      ></i>
      <div
        class="absolute right-full w-[6vw] h-[3vw] p-[0.5vw] bg-[#05358CCC] text-white font-harmony text-[1vw] transform scale-x-0 opacity-0 transition-all duration-300 origin-right whitespace-nowrap group-hover:scale-x-100 group-hover:opacity-100 flex justify-center items-center will-change-auto"
      >
        全国加盟
      </div>
    </div>

    <!-- 回到顶部 -->
    <div
      class="relative group w-[3vw] h-[3vw] bg-[#9CA3AFCC] flex items-center justify-center hover:bg-[#05358CCC] cursor-pointer"
      @click="smoothScrollToTop"
    >
      <i class="el-icon-top text-[1.4vw] text-white" alt="回到顶部"></i>
      <div
        class="absolute right-full w-[6vw] h-[3vw] p-[0.5vw] bg-[#05358CCC] text-white font-harmony text-[1vw] transform scale-x-0 opacity-0 transition-all duration-300 origin-right whitespace-nowrap group-hover:scale-x-100 group-hover:opacity-100 flex justify-center items-center will-change-auto"
      >
        回到顶部
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 平滑滚动到顶部
    smoothScrollToTop() {
      const startPosition = window.scrollY || window.pageYOffset;
      const distance = -startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
        window.scrollTo(0, run);
        if (timeElapsed < 1000) requestAnimationFrame(animation);
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    },
  },
};
</script>
